import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationAmount from './ConfirmationAmount';
import ConfirmationAmountGiftAid from './ConfirmationAmountGiftAid';

const ConfirmationMessage = ({
  yourDonation,
  giftaidFlag,
  extraDonateAmount,
  giftAid,
}) => {
  return (
    <div className="confirmation_header" role="text">
      <ConfirmationAmount message={yourDonation} />
      {giftaidFlag && (
        <ConfirmationAmountGiftAid
          extraDonateAmount={extraDonateAmount}
          giftAid={giftAid}
        />
      )}
    </div>
  );
};

ConfirmationMessage.propTypes = {
  yourDonation: PropTypes.object,
  giftaidFlag: PropTypes.bool,
  extraDonateAmount: PropTypes.string,
  giftAid: PropTypes.string,
};

export default ConfirmationMessage;
